;( function( $, undefined )
{
    $.fn.PrivateMessageDetail = function()
    {
        var $new             = $( '#private-message-detail' )
          , $old             = $new.prev()
          , $prevButton      = $( '#pdc6-button-prev' )
          , $nextButton      = $( '#pdc6-button-next' )
          , $addToFavs       = $( '#add-user-favs' )
          , $ignoreUser      = $( '#ignore-this-user' )
          , deleteLink       = $old.find( '.delete-link' ).attr( 'href' )
          , replyLink        = $old.find( '.reply-link' ).attr( 'href' )
          , addFriendLink    = $old.find( '.add-friend-link' ).attr( 'href' )
          , deleteFriendLink = $old.find( '.delete-friend-link' ).attr( 'href' )
          , ignoreUserLink   = $old.find( '.add-ignore-link' ).attr( 'href' )
          , removeIgnoreLink = $old.find( '.delete-ignore-link' ).attr( 'href' );

        if( $old.find( '.lia-paging-page-next' ).size() )
        {
            $nextButton.attr( 'href', $old.find( '.lia-paging-page-next' ).find( 'a' ).attr( 'href' ) );
        }
        else
        {
            $nextButton.addClass( 'disabled' ).click( function( e )
            {
                e && e.preventDefault();
            } );
        }

        var $content = $old.find( '.lia-message-body-content' );

        $content.find( 'p' ).each( function()
        {
            var $this = $( this );

            if( $this.html().replace( /\s|&nbsp;/g, '' ).length == 0 )
            {
                $this.remove();
            }
        } );

        $( '#pm-message-body' ).html( '' ).append( $content );

        if( $old.find( '.lia-paging-page-previous' ).size() )
        {
            $prevButton.attr( 'href', $old.find( '.lia-paging-page-previous' ).find( 'a' ).attr( 'href' ) );
        }
        else
        {
            $prevButton.addClass( 'disabled' ).click( function( e )
            {
                e && e.preventDefault();
            } );
        }

        //$addToFavs.attr( 'href', addFriendLink ? addFriendLink : deleteFriendLink );
        $ignoreUser.attr( 'href', ignoreUserLink ? ignoreUserLink : removeIgnoreLink );

        $ignoreUser.on('click', function (e) {
            e && e.preventDefault();

            var id = $addToFavs.data('id');
            var action = ignoreUserLink ? 'add' : 'remove';

            $.ajax( {
                type     : 'POST',
                dataType : 'json',
                url      : '/restapi/vc/users/id/' + LITHIUM.CommunityJsonObject.User.id + '/addressbook/contacts/ignores/' + action + '?contacts.user=id/' + id,
                complete : function () {
                    window.location.reload();
                }
            } );
        });

        $new.find( '.reply-link' ).attr( 'href', replyLink );
        //$new.find( '.delete-link' ).attr( 'href', deleteLink );
        $new.find( '.delete-link' ).on( 'click', function( e )
        {
            e && e.preventDefault();

            LITHIUM.jQuery( '.lia-message-actions .delete-link' ).trigger( 'click' );
        } );

    };

} )( jQuery );